<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="ui.btnColor"> source </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor">
          <v-card-title :class="ui.textTitle">
            {{role.char.type}}
            <v-spacer/>
            {{displayDocumentIDGTypeA("G4", role.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row>
                <v-chip :color="ui.chipColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                    {{role.basic.idi}}
                  </v-avatar>
                  {{role.basic.title}}
                </v-chip>
              </v-layout>
              <v-layout row v-if="role.char.person ===  'Required'" class="ml-1">
                <div v-if="role.user.udid ===  ''">
                  <v-avatar>
                    <v-icon :color="ui.colorWarning">warning</v-icon>
                  </v-avatar>
                  <v-chip :color="ui.chipColor" :text-color="ui.colorWarning" class="subheading">
                    No User Assigned
                  </v-chip>
                </div>
                <div v-else>
                  <v-avatar>
                    <v-icon :color="ui.btnColor">
                      {{role.char.icon}}
                    </v-icon>
                  </v-avatar>
                  <v-chip :color="ui.chipColor" :class="ui.textDescription">
                    <div :class="ui.textDescription">
                      {{role.user.uname}}, {{role.user.uemail}}
                    </div>
                  </v-chip>
                </div>
              </v-layout>
              <v-layout row wrap class="ml-2">
                <v-flex xs12 sm5>
                  <v-text-field
                    v-model="role.char.type"
                    prepend-icon="person"
                    hint="role"
                    persistent-hint
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5>
                  <v-text-field
                    v-model="role.char.ref"
                    prepend-icon="bookmark"
                    hint="reference"
                    persistent-hint
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
                  <v-layout row wrap class="ml-2">
                <v-flex xs12 sm5>
                  <v-text-field
                    v-model="role.char.person"
                    prepend-icon="group_add"
                    hint="assignee"
                    persistent-hint
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5>
                  <v-text-field
                    v-model="role.char.crit"
                    prepend-icon="priority_high"
                    hint="priority"
                    persistent-hint
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2">
                <v-flex xs12 sm10>
                  <v-text-field
                    v-model="role.char.theme"
                    prepend-icon="grid_view"
                    hint="position"
                    persistent-hint
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="ml-2" accesskey="">
                <v-flex xs12 sm10>
                  <v-text-field
                    v-model="role.char.obj"
                    label="role objective"
                    prepend-icon="account_box"
                    hint="name"
                    persistent-hint
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Role and Responsibilities Description
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{role.char.resp}}
                </div>
              </v-layout>
            </v-container>
            <v-layout row>
              <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
                <v-icon left> exit_to_app </v-icon>
                Close
              </v-btn>
              <v-spacer/>
              <RoleUserAssign :data="{role: this.role, btnType: 'flat'}"
              v-if="enableRoleFunctions"/>
              </v-layout>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import RoleUserAssign from "@/support/roles/components/RoleUserAssign";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import manipulateList from "@/globals/edits/mixins/manipulateList.js";
import master from "@/data/forms/mixins/master.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
export default {
  // eslint-disable-next-lineprog
  mixins: [
    master,
    dateFunctions,
    apptheme,
    manipulateList,
    numberFunctions,
    displayFunctions,
    docRevsModFunctions
  ],
  components: {
    RoleUserAssign
  },
  computed: {
    ...mapGetters([
      "getTransitions",
      "getCurrentPage",
      "getRolesList",
      "getDetail",
      "getTransitions"
    ]),
    enableRoleFunctions() {
      let logic = null;
      let status = null;
      if (this.getTransitions !== null && this.getTransitions !== undefined) {
        let flow = this.getTransitions.flow;
        status = flow[flow.length - 1].title;
      }
      if (status === "Closed") {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    }
  },
  props: {
    role: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      valid: false
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    assignRole() {
      this.dialog = false;
    },
    moveUpItem(u) {
      this.saveDocumentRevMod(5.31); // Role updated
      let tempRoleList = this.moveListItem("up", u, this.getRolesList);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.$store.dispatch("changeRolesList", tempRoleList);
      this.dialog = false;
    },
    moveDownItem(u) {
      this.saveDocumentRevMod(5.32); // Role updated
      let tempRoleList = this.moveListItem("down", u, this.getRolesList);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.$store.dispatch("changeRolesList", tempRoleList);
      this.dialog = false;
    }
  }
};
</script>
